import safelyIncrement from '../../helpers/safelyIncrement';

export default (state, action) => {
  const { estimateCount, containerCount, itemCount } = state;
  const { estimate, container } = action.payload;

  const updatedContainerCount = { ...containerCount, [estimate.designId]: 1 };
  const updatedItemCount = { ...itemCount, [container.containerId]: 1 };

  return {
    ...state,
    selectedEstimate: estimate.designId,
    estimateCount: safelyIncrement(estimateCount),
    containerCount: updatedContainerCount,
    itemCount: updatedItemCount,
  };
};
